<template>
  <div class="app-body" ref="appBody">
  <el-tabs v-model="currentTab" type="card" @tab-click="tabClickHandler">
    <el-tab-pane label="发票明细" name="PayDetailTable">
      <PayDetailTable ref="PayDetailTable"  v-if="currentTab==='PayDetailTable'" :receipt-type="receiptType"></PayDetailTable>
    </el-tab-pane>
    <el-tab-pane label="发票单" name="PayFormTable">
      <PayFormTable ref="PayFormTable" v-if="currentTab==='PayFormTable'" :receipt-type="receiptType"></PayFormTable>
    </el-tab-pane>
  </el-tabs>
  </div>
</template>

<script>
import PayDetailTable from '@/views/modules/erp/pay/pay-detail-table.vue'
import PayFormTable from '@/views/modules/erp/pay/pay-form-table.vue'

export default {
  components: { PayDetailTable, PayFormTable },
  data () {
    return {
      currentTab: 'PayDetailTable',
      receiptType:'make'
    }
  },
  activated () {
    this.reload()
  },
  methods: {
    tabClickHandler(e){
      this.$nextTick(()=>{
        this.$refs[this.currentTab].reload()
      })
    },
    reload () {
      this.$nextTick(() => {
        this.$refs[this.currentTab].reload()
      })
    }

  }
}
</script>

<style scoped>

</style>
